import "./App.css";
import { Routes, Route, Navigate, Link } from "react-router-dom";
import Product from "./pages/Product";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Checkout from "./pages/Checkout";
import { useSelector, useDispatch } from "react-redux";
import Header from "./components/Header";
import Cart from "./components/Cart";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import Admin from "./pages/Admin";
import Products from "./pages/admin/Products";
import EditProduct from "./pages/admin/EditProduct";
import ContactUs from "./pages/ContactUs";
import Password from "./pages/Password";
import Catalog from "./pages/Catalog";
import ScrollToTop from "./ScrollToTop";
import AboutProject from "./pages/AboutProject";
import { ToastContainer } from "react-toastify";
import "./assets/ReactToastify.css";
import WelcomeModal from "./components/WelcomeModal";
import { showModal, hideModal } from "./redux/showLogModalSlice";
import React from "react";
import Orders from "./pages/Orders";
import SuccessBuy from "./pages/SuccessBuy";

const ProtectedRoute = ({ token, children }) => {
  if (token.token) {
    return children;
  }
  return <Navigate to="/login" />;
};

function App() {
  React.useEffect(() => {
    window.addEventListener("unload", handleResetModal);

    return () => {
      window.removeEventListener("unload", handleResetModal);
    };
  }, []);

  const dispatch = useDispatch();
  const showLogModal = useSelector((state) => {
    return state.showLogModal;
  });
  const token = useSelector((state) => {
    return state.token;
  });

  const handleHideModal = async () => {
    dispatch(hideModal());
  };

  const handleResetModal = async () => {
    dispatch(showModal());
  };

  return (
    <div className="App" style={{ backgroundColor: "#F9F9F9" }}>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/catalog" element={<Catalog />} />
        <Route path="/product/:slug" element={<Product />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/password" element={<Password />} />
        <Route path="/about-project" element={<AboutProject />} />
        <Route
          path="/checkout"
          element={
            <ProtectedRoute token={token}>
              <Checkout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/success"
          element={
            <ProtectedRoute token={token}>
              <SuccessBuy />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <ProtectedRoute token={token}>
              <Orders />
            </ProtectedRoute>
          }
        />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/products" element={<Products />} />
        <Route path="/admin/products/:id" element={<EditProduct />} />
      </Routes>
      <ScrollToTop />
      <Footer />
      <Link
        id="about-project-fix"
        className="px-3 py-2 rounded-2 border-0 about-project-fix fw-bold btn btn-dark"
        to="/about-project"
      >
        About Project
      </Link>
      <ToastContainer />
      {/* <WelcomeModal show={showLogModal} onHide={handleHideModal} /> */}
    </div>
  );
}

export default App;
